import moment from "moment";
import { useDateFormatter } from "PFCore/hooks/use_date_formatter";

export const usePlannerDefaultOrder = () => {
  const { formatISODate } = useDateFormatter();

  return {
    direction: "desc",
    end_date: formatISODate(moment().add(1, "months")),
    name: ["available_minutes"],
    start_date: formatISODate(),
    text: "Available minutes desc"
  };
};
